module['exports']=Array['isArray']||function(_0xd778b8){return Object['prototype']['toString']['call'](_0xd778b8)=='[object\x20Array]';};